//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getLike2BuySummaryInsights = createSelector(
  (state: ICuralateStore) => state.insights,
  (insights) => insights.like2BuySummary,
);
